import type { S3Bucket } from '@repo/api-gw-sdk';

import {
  PREDEFINED_DUAL_REGION_CONSTITUENTS,
  isPredefinedDualRegionLabel,
  isPredefinedMultiOrDualRegionLabel,
  isPredefinedMultiRegionLabel,
} from '@/utils/gcsRegion';

export interface NormalizedBucket extends S3Bucket {
  locationType?: string;
  constituentRegions?: string[];
}

export const isBucketInRegion = (
  bucket: NormalizedBucket,
  region: string
): boolean => {
  const upperRegion = region.toUpperCase();
  const upperName = bucket.regionName?.toUpperCase() ?? '';

  if (
    bucket.locationType === 'multi-region' &&
    upperName === upperRegion &&
    isPredefinedMultiRegionLabel(region)
  ) {
    return true;
  }
  if (
    bucket.locationType === 'dual-region' &&
    upperName === upperRegion &&
    isPredefinedDualRegionLabel(region)
  ) {
    return true;
  }
  // Regional literal match — guarded against multi/dual-region geography
  // labels (e.g. 'US') so a custom dual-region in US geography isn't caught
  // by filter 'US'.
  if (
    bucket.regionName === region &&
    !isPredefinedMultiOrDualRegionLabel(bucket.regionName)
  ) {
    return true;
  }
  if (bucket.constituentRegions?.includes(region)) {
    return true;
  }
  if (bucket.locationType === 'dual-region') {
    const predefined = PREDEFINED_DUAL_REGION_CONSTITUENTS[upperName];
    if (predefined?.includes(region)) {
      return true;
    }
  }
  return false;
};
